// store/auth.js

// import * as dashboard from './user';
import axios from "axios";
import { apis } from '../../apis/community';
import router from "../../../router/routes";

const state = {
    // Additional state if needed
    communityData: [],
    communityByIdData: [],
    mostVisitedCommunity: [],
}

const mutations = {
    SET_COMMUNITY_DATA(state, data) {
        state.communityData = data
    },
    SET_COMMUNITY_BY_ID_DATA(state, data) {
        state.communityByIdData = data
    },
    SET_COMMUNITY_MOST_VISITED_DATA(state, data) {
        state.mostVisitedCommunity = data
    },
}

const actions = {
    // Additional actions if needed

    getCommunity({ commit }) {
          // return
          // return new Promise((resolve, reject) => {
              axios
                  .get(axios.defaults.baseURL + apis.GET_COMMUNITY,{
                      headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                      },
                    })
                  .then((res) => {
                      console.log('getCommunity res', res)
                      if(Array.isArray(res.data.data)){
                        commit('SET_COMMUNITY_DATA', res.data.data)
                      }
                      else{
                        commit('SET_COMMUNITY_DATA', res.data.data.message)
                      }
                  })
                  .catch((err) => {
                      console.log('getCommunity err', err)
                  })
          // })
    },

    getCommunityMostVisited({ commit }) {
          // return
          // return new Promise((resolve, reject) => {
              axios
                  .get(axios.defaults.baseURL + apis.GET_COMMUNITY_MOST_VISITED,{
                      headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                      },
                    })
                  .then((res) => {
                      console.log('getCommunityMostVisited res', res)
                      if(Array.isArray(res.data)){
                        commit('SET_COMMUNITY_MOST_VISITED_DATA', res.data)
                      }
                      else{
                        commit('SET_COMMUNITY_MOST_VISITED_DATA', res.data.message)
                      }
                  })
                  .catch((err) => {
                      console.log('getCommunityMostVisited err', err)
                  })
          // })
    },

    getCommunityById({ commit }, id) {
          // return
          // return new Promise((resolve, reject) => {
              axios
                  .get(axios.defaults.baseURL + apis.GET_COMMUNITY_BY_ID + id, {
                      headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                      },
                    })
                  .then((res) => {
                      console.log('getCommunityById res', res)
                      if(Array.isArray(res.data.data)){
                        commit('SET_COMMUNITY_BY_ID_DATA', res.data.data[0])
                      }
                      else{
                        commit('SET_COMMUNITY_BY_ID_DATA', res.data.data[0].message)
                      }
                  })
                  .catch((err) => {
                      console.log('getCommunityById err', err)
                  })
          // })
    },

    AddReview_ForDriver({dispatch, commit}, payload) {
        console.log("payload--", payload);
        // return
        var formData = new FormData();
        formData.append("user_id", payload.user_id);
        formData.append("review_id", payload.review_id);
        formData.append("headline", payload.headline);
        formData.append("ratings", payload.ratings);
        formData.append("description", payload.description);
        formData.append("home_time", '');
        formData.append("equipment", '');
        formData.append("dispatches", '');
        formData.append("status", payload.status);
        return new Promise((resolve, reject) => {
          axios
            .post(axios.defaults.baseURL + apis.ADD_REVIEW_FOR_DRIVER, formData,{
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            })
            .then((res) => {
              console.log("AddReview_ForDriver res", res);
              commit("UPDATE_LOADING_STATE", false);
              resolve(res);
              dispatch("checkErrorAndSendToast", [
                res,
                "success",
              ]);
              router.push("/company")
            })
            .catch((err) => {
              console.log("AddReview_ForDriver err", err);
              reject(err);
              dispatch("checkErrorAndSendToast", [
                err.response,
                "error",
              ]);
            });
        })
      },

    Add_Outside_Review_ForDriver({dispatch, commit}, payload) {
        console.log("payload--", payload);
        // return
        var formData = new FormData();
        formData.append("review_id", payload.review_id);
        formData.append("driver", payload.driver);
        formData.append("dob", payload.dob);
        formData.append("headline", payload.headline);
        formData.append("ratings", payload.ratings);
        formData.append("description", payload.description);
        formData.append("status", payload.status);
        return new Promise((resolve, reject) => {
          axios
            .post(axios.defaults.baseURL + apis.ADD_OUTSIDE_REVIEW_FOR_DRIVER, formData, {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            })
            .then((res) => {
              console.log("Add_Outside_Review_ForDriver res", res);
              commit("UPDATE_LOADING_STATE", false);
              resolve(res);
              dispatch("checkErrorAndSendToast", [
                res,
                "success",
              ]);
              router.push("/all-drivers")
            })
            .catch((err) => {
              console.log("Add_Outside_Review_ForDriver err", err);
              reject(err);
              dispatch("checkErrorAndSendToast", [
                err.response,
                "error",
              ]);
            });
        })
      },

      postSubscription({dispatch, commit}, payload) {
        console.log("payload--", payload);
        // return
        var formData = new FormData();
        formData.append("user_id", payload.user_id);
        formData.append("amount", payload.amount);
        formData.append("end_date", payload.end_date);
        return new Promise((resolve, reject) => {
          axios
            .post(axios.defaults.baseURL + apis.SUBSCRIPTION, formData,{
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            })
            .then((res) => {
              console.log("postSubscription res", res);
              commit("UPDATE_LOADING_STATE", false);
              resolve(res);
              dispatch("checkErrorAndSendToast", [
                res,
                "success",
              ]);
              // router.push("/company")
            })
            .catch((err) => {
              console.log("postSubscription err", err);
              reject(err);
              dispatch("checkErrorAndSendToast", [
                err.response,
                "error",
              ]);
            });
        })
      },

}

const getters = {
    // Additional getters if needed
}

export default {
    state,
    mutations,
    actions,
    getters,
  };